/**
 * Converts camelCase to Title Case
 * Example: camelCase -> Camel Case
 * @param str The string to convert
 * @returns The title-cased string
 */
export function toTitleCase(str: string): string {
  const spaced = str.replace(/([A-Z])/g, " $1");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

/**
 * Splits a file name into two parts: the file name and the file extension
 * Example: "file.pdf" => ["file", ".pdf"];
 * @param name The file name to split
 * @returns An array of [name, extension]
 */
export function splitFileNameAndExtension(name: string): [string, string] {
  const fileExtensionRegex = /\.[0-9a-z]{1,5}$/i;
  const extensionMatch = name.match(fileExtensionRegex);
  const extension =
    extensionMatch && extensionMatch.length ? extensionMatch[0] : "";
  const fileName = name.replace(fileExtensionRegex, "");
  return [fileName, extension];
}

export function stripQuery(urlStr: string) {
  const url = new URL(urlStr);
  return url.protocol + "//" + url.host + url.pathname;
}

export function isUrl(str: string) {
  // returns true if str starts with http:// or https:// or www.
  // and has at least 1 character after that
  return /^(http|https):\/\/[^ "]+$/.test(str) || /^www.[^ "]+$/.test(str);
}

export function isSudoziUrl(str: string) {
  return (
    str.startsWith("https://baking-beans.sudozi.com") ||
    str.startsWith("https://beans.sudozi.com")
  );
}

export function firstNWords(str: string, n: number) {
  const words = str.split(" ");
  if (words.length <= n) {
    return str;
  }

  return `${words.slice(0, n).join(" ")}...`;
}

/**
 * @example
 * firstItemAndCount(["a", "b", "c"], (item) => item)
 * // "a, +2"
 *
 * @example
 * firstItemAndCount([{name: "a"}], (item) => item.name)
 * // "a"
 */
export function firstItemAndCount<T>(arr: T[], get: (item: T) => string) {
  return arr.length === 0
    ? ""
    : arr.length === 1
    ? get(arr[0])
    : `${get(arr[0])}, +${arr.length - 1}`;
}
